export function canAccessAdminSettings(clinicRole, isPlatformAdmin = false) {
  return clinicRole === "clinic_admin" || !!isPlatformAdmin;
}

export function canAccessOwnerFrontDeskSettings(clinicRole, isPlatformAdmin = false) {
  return clinicRole === "clinic_admin" || clinicRole === "receptionist" || !!isPlatformAdmin;
}
